export const CREATE_REQUEST = 'CREATE_REQUEST';
export const DELETE_REQUEST = 'DELETE_REQUEST';
export const FETCH_REQUESTS = 'FETCH_REQUESTS';
